import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=44263906&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44263906')) {
      api.createRecord('44263906', component.options)
    } else {
      api.reload('44263906', component.options)
    }
    module.hot.accept("./ProfileTab.vue?vue&type=template&id=44263906&", function () {
      api.rerender('44263906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/ProfileScreen/ProfileTab.vue"
export default component.exports